// Numeric UI message categories avoid treating internal identifiers as credential-like strings.
export const AUTHENTICATION_REQUIRED_MESSAGE_KEY = 1;
export const AUTHENTICATION_REQUIRED_MESSAGE = "Not logged in. Please log in and try again.";
export const AUTHENTICATION_CHECK_ERROR_MESSAGE_KEY = 2;
